import { render, staticRenderFns } from "./simplifyContract.vue?vue&type=template&id=27c2f8b8&scoped=true"
import script from "./simplifyContract.vue?vue&type=script&lang=js"
export * from "./simplifyContract.vue?vue&type=script&lang=js"
import style0 from "./simplifyContract.vue?vue&type=style&index=0&id=27c2f8b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c2f8b8",
  null
  
)

export default component.exports